(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-search-results]');
      this.status = this.querySelector('[data-predictive-search-status]');
      this.cache = new Map();

      this.input.addEventListener('input', () => {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.search(), 300);
      });

      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.input.value) {
          event.stopPropagation();
          this.input.value = '';
          this.clear();
        }
      });
    }

    async search() {
      const terms = this.input.value.trim();

      if (!terms) {
        this.clear();
        return;
      }

      this.controller?.abort();

      if (this.cache.has(terms)) {
        this.render(this.cache.get(terms));
        return;
      }

      this.controller = new AbortController();
      this.setAttribute('loading', '');

      const params = new URLSearchParams({
        q: terms,
        section_id: 'predictive-search',
        'resources[type]': 'query,product,collection,page,article',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
      });

      try {
        const response = await fetch(`${this.dataset.url}?${params}`, { signal: this.controller.signal });

        if (!response.ok) throw new Error(response.status);

        const html = new DOMParser()
          .parseFromString(await response.text(), 'text/html')
          .getElementById('predictive-search-results');

        this.cache.set(terms, html);
        this.render(html);
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.clear();
      }
    }

    render(html) {
      this.removeAttribute('loading');

      if (!html) {
        this.clear();
        return;
      }

      this.results.replaceChildren(...html.cloneNode(true).childNodes);
      this.status.textContent = html.dataset.status;
    }

    clear() {
      this.controller?.abort();
      this.removeAttribute('loading');
      this.results.replaceChildren();
      this.status.textContent = '';
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-media"] && !Shopify.designMode) return;
  try {
    class CardModel {
    constructor(container) {
      this.container = container;
      this.viewer = container.querySelector('[data-card-viewer]');
      this.loaded = false;
      this.container.addEventListener('pointerenter', this.activate.bind(this));
      this.container.addEventListener('pointerleave', this.deactivate.bind(this));
    }

    activate() {
      if (!this.viewer) return;

      if (this.loaded) {
        this.reveal();
        return;
      }

      this.loaded = true;

      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures(
          [{ name: 'model-viewer-ui', version: '1.0' }],
          (error) => {
            if (error) return;
            this.reveal();
          }
        );
      } else {
        // model-viewer already registered elsewhere on the page.
        this.reveal();
      }
    }

    reveal() {
      this.container.classList.add('is-active');
      if (typeof this.viewer.dismissPoster === 'function') {
        this.viewer.dismissPoster();
      }
    }

    deactivate() {
      this.container.classList.remove('is-active');
      if (this.viewer && typeof this.viewer.showPoster === 'function') {
        this.viewer.showPoster();
      }
    }
  }

  function initCardModels() {
    document.querySelectorAll('[data-card-model]').forEach((container) => {
      if (container.dataset.cardModelInit) return;
      container.dataset.cardModelInit = 'true';
      new CardModel(container);
    });
  }

  if (document.readyState !== 'loading') {
    initCardModels();
  } else {
    document.addEventListener('DOMContentLoaded', initCardModels);
  }

  document.addEventListener('shopify:section:load', initCardModels);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-hero-media"] && !Shopify.designMode) return;
  try {
    // How long the turn-to-front and turn-180 moves take, in milliseconds.
  const HERO_MODEL_TURN_MS = 600;
  // Treat a pointer as a click, not a drag, within this movement and time.
  const HERO_MODEL_CLICK_PX = 6;
  const HERO_MODEL_CLICK_MS = 500;

  // Which way the idle spin runs, matching `rotation-per-second` on the
  // model-viewer tag above: 1 for a positive value, -1 for a negative one.
  // Settling on the *next* side depends on knowing this direction.
  const HERO_MODEL_SPIN_SIGN = 1;

  // Hovering settles the model on a quarter turn; clicking turns it a half.
  const HERO_MODEL_SNAP = Math.PI / 2;
  const HERO_MODEL_CLICK_TURN = Math.PI;

  // The next quarter turn the idle spin would bring around, from the given yaw.
  // Already sitting on one counts as arriving, so hovering there holds it still.
  function nextSide(yaw) {
    const sides = yaw / HERO_MODEL_SNAP;
    if (HERO_MODEL_SPIN_SIGN > 0) {
      return Math.ceil(sides) * HERO_MODEL_SNAP;
    }
    return Math.floor(sides) * HERO_MODEL_SNAP;
  }

  function easeInOutCubic(t) {
    if (t < 0.5) return 4 * t * t * t;
    return 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  class HeroModel {
    constructor(container) {
      this.container = container;
      this.viewer = container.querySelector('[data-hero-viewer]');
      if (!this.viewer) return;

      this.frame = null;
      this.targetYaw = 0;
      this.pointer = null;

      // Respect a shopper's reduced-motion preference: no unprompted spinning,
      // and the interaction turns land instantly rather than animating.
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.reduceMotion.matches) {
        this.viewer.removeAttribute('auto-rotate');
      }

      this.container.addEventListener('pointerenter', this.hold.bind(this));
      this.container.addEventListener('pointerleave', this.release.bind(this));
      this.container.addEventListener('pointerdown', this.onPointerDown.bind(this));
      this.container.addEventListener('pointerup', this.onPointerUp.bind(this));
      this.container.addEventListener('pointercancel', this.clearPointer.bind(this));

      this.load();
    }

    load() {
      if (window.customElements && window.customElements.get('model-viewer')) {
        this.reveal();
        return;
      }

      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures(
          [{ name: 'model-viewer-ui', version: '1.0' }],
          (error) => {
            if (error) return;
            this.reveal();
          }
        );
      }
    }

    reveal() {
      this.container.classList.add('is-loaded');
      if (typeof this.viewer.dismissPoster === 'function') {
        this.viewer.dismissPoster();
      }
    }

    get yaw() {
      if (typeof this.viewer.turntableRotation === 'number') {
        return this.viewer.turntableRotation;
      }
      return 0;
    }

    setYaw(value) {
      if (typeof this.viewer.resetTurntableRotation === 'function') {
        this.viewer.resetTurntableRotation(value);
      }
    }

    // Stop spinning and settle on the quarter turn the spin was heading towards.
    hold() {
      this.viewer.autoRotate = false;
      this.turnTo(nextSide(this.yaw));
    }

    // Turn a half revolution further, continuing the spin's own direction.
    flip() {
      this.turnTo(this.targetYaw + HERO_MODEL_CLICK_TURN * HERO_MODEL_SPIN_SIGN);
    }

    // Hand the model back to its own rotation, from wherever it now sits.
    release() {
      this.stopTurn();
      if (!this.reduceMotion.matches) {
        this.viewer.autoRotate = true;
      }
    }

    turnTo(target) {
      this.stopTurn();
      this.targetYaw = target;

      const from = this.yaw;
      const delta = target - from;

      if (this.reduceMotion.matches || Math.abs(delta) < 0.001) {
        this.setYaw(target);
        return;
      }

      const start = performance.now();
      const step = (now) => {
        const elapsed = now - start;
        const progress = Math.min(elapsed / HERO_MODEL_TURN_MS, 1);
        this.setYaw(from + delta * easeInOutCubic(progress));

        if (progress < 1) {
          this.frame = requestAnimationFrame(step);
        } else {
          this.frame = null;
        }
      };

      this.frame = requestAnimationFrame(step);
    }

    stopTurn() {
      if (this.frame !== null) {
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    }

    onPointerDown(event) {
      this.pointer = { x: event.clientX, y: event.clientY, at: performance.now() };
    }

    // A tap or click turns the model; a swipe is someone scrolling past it.
    onPointerUp(event) {
      if (!this.pointer) return;

      const movedX = event.clientX - this.pointer.x;
      const movedY = event.clientY - this.pointer.y;
      const moved = Math.sqrt(movedX * movedX + movedY * movedY);
      const elapsed = performance.now() - this.pointer.at;
      this.clearPointer();

      if (moved > HERO_MODEL_CLICK_PX) return;
      if (elapsed > HERO_MODEL_CLICK_MS) return;

      // Touch gets no hover, so make sure the spin is stopped first.
      this.viewer.autoRotate = false;

      this.flip();
    }

    clearPointer() {
      this.pointer = null;
    }
  }

  function initHeroModels() {
    document.querySelectorAll('[data-hero-model]').forEach((container) => {
      if (container.dataset.heroModelInit) return;
      container.dataset.heroModelInit = 'true';
      new HeroModel(container);
    });
  }

  if (document.readyState !== 'loading') {
    initHeroModels();
  } else {
    document.addEventListener('DOMContentLoaded', initHeroModels);
  }

  document.addEventListener('shopify:section:load', initHeroModels);
  } catch(e) { console.error(e); }
})();

})();
